/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  IssuePromoLinkBatchOptions,
  IssuePromoLinkBatchResponses,
} from '../types/IssuePromoLinkBatch'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Mint single-use links or one reusable link bound to an existing affiliate program/member/code. Requires Idempotency-Key. Only committed new-user signups consume the shared campaign max_users limit; unused single-use links have no reserved place. Uses DORA-6544 campaign-grant authorization. Affiliate selection also requires independent access to the selected program. Migration 208 must precede reusable-link migration 209. Enable reusable creation in FE after all API replicas and reward-settlement daemon processes support this contract; older replicas fail closed instead of consuming reusable links. No program-only codes or landing-page selector. ADMIN, same-tenant INTEGRATOR, or AFFILIATE_MANAGER explicitly assigned to the owning QR campaign (including across tenants). Grants are checked on every request; tenant filters do not confer access. Exact idempotent replays return 200; first creation returns 201; key reuse with another payload returns 409.
 * @summary Issue a promotional link batch
 * {@link /v1/trading_challenges/:trading_challenge_id/link_batches}
 */
export function issuePromoLinkBatch<ThrowOnError extends boolean = true>(
  options: Options<IssuePromoLinkBatchOptions, ThrowOnError>,
): Unwrappable<RequestResult<IssuePromoLinkBatchResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/trading_challenges/{trading_challenge_id}/link_batches',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<IssuePromoLinkBatchResponses, ThrowOnError>>,
  )
}
